export default __webpack_public_path__ + "static/media/planet9.04feee74.png";